import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'apps/trix/src/environments/environment';
import { EMPTY, map } from 'rxjs';
import { MetricGroup, MetricGroupListSchema, MetricGroupSchema } from '..';
import { MessageTypeEnum, schemaControl, SignalStoreModel, snackbarError } from '../../../../shared/signal-store';

@Injectable()
export class MetricGroupService implements SignalStoreModel<MetricGroup, MetricGroup> {
  private readonly http = inject(HttpClient);
  private readonly snackBar = inject(MatSnackBar);

  public readonly NAME = 'metric_group';
  public readonly API = `${environment.directoryApi}/metric_groups`;

  fetchAll(transferCache = true) {
    return this.http.get<Record<string, { metrics?: Array<{ metric: string; 'data-export'?: boolean }> }>>(
      `${this.API}`,
      { transferCache }
    ).pipe(
      map((rawGroups) =>
        Object.entries(rawGroups).map(([name, data]) => ({
          id: name,
          name,
          metrics: (data.metrics ?? []).map(x => ({
            name: x.metric,
            isExportable: x['data-export'] ?? false
          }))
        }))
      ),
      schemaControl(MetricGroupListSchema),
      snackbarError(this.snackBar, MessageTypeEnum.FETCHED, `${this.NAME}s`)
    );
  }

  fetchById(id: string) {
    return this.http.get(`${this.API}/${id}`).pipe(
      schemaControl(MetricGroupSchema),
      snackbarError(this.snackBar, MessageTypeEnum.FETCHED, this.NAME)
    );
  }

  createOne(_entity: MetricGroup) {
    return EMPTY as unknown as ReturnType<typeof this.fetchById>;
  }

  updateOne(_id: string, _entity: MetricGroup) {
    return EMPTY as unknown as ReturnType<typeof this.fetchById>;
  }

  deleteOne(_id: string) {
    return EMPTY;
  }
}
